import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, ContactTwo, FooterTwo } from "../containers";

const Contact = () => (
  <Fragment>
    <Seo
      title="Contact Us"
      description="Get in touch with Tech Ayukta for IT Consulting, Web Development, App Development, and ERP Solutions."
      keywords="Tech Ayukta Contact, IT Consulting, Web Development, ERP Solutions"
      canonical="https://www.techayukta.com/contact"
    />
    <HeaderThree />
    <Breadcrumb
      pageName="Contact Us"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ContactTwo className="space-top space-extra-bottom" />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default Contact;
